module.exports = __webpack_public_path__ + "img/x6.3bb2135d.jpg";